import React, { useState }              from 'react';
import { useDispatch, useSelector }     from 'react-redux';
import { Button }                       from 'react-bootstrap';

import { ICON_INFO, ICON_REFRESH }      from '../../../extras/icons';
import { JUEZ_RESORTEAR }               from '../../../../data/objects';

import MotivoResorteo                   from './forms/MotivoResorteo';
import MotivoResorteoForm               from './forms/MotivoResorteoForm';

import Authorities                      from '../../../../services/AuthoritiesService';
import judgeSelectionType               from '../../../../data/judgeSelectionType';

import { listAudienceMotivesAction }    from '../../../../actions/audienceMotivesActions';





const AudienceActualJudges = props => {



    // ==========================================================================================
    // TOMO LOS PROPS ---------------------------------------------------------------------------
    // ==========================================================================================
    const { audience } = props;
    
    

    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================    
    const dispatch = useDispatch();

    const [datosJuez, setDatosJuez] = useState('');
    const [showMotivo, setShowMotivo] = useState(false);
    const [showResortear, setShowResortear] = useState(false);
    const [ResorteoDto, setResorteoDto] = useState({
        "juezId": '',
        "motivo": {
            "id": '',
            "descripcion": ''
        },
        "observaciones": ''
    });    
        
    
    
    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================
    const authorities = useSelector(state => state.auth.authorities);
    
    
    
    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================

    // Manejo la apertura de la ventana
    const handleOpenResortear = () => {
        dispatch( listAudienceMotivesAction() );
        setShowResortear(true);
    }
    const handleOpenMotivo = () => {
        setShowMotivo(true);
    }

    // Manejo el cierre de la ventana
    const handleCloseResortear = () => {
        setShowResortear(false);
    }
    const handleCloseMotivo = () => {
        setShowMotivo(false);
    }

    // Muestra el modal
    const mostrarResortear = (idJuez) => {
        ResorteoDto.juezId = idJuez;
        handleOpenResortear();
    }
    const mostrarMotivo = (juez) => {
        setDatosJuez(juez);
        handleOpenMotivo();
    }



    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================    
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">JUEZ/CES SELECCIONADO/S</h6>
                </div>
                <table className="table table-hover table-sm">
                    <thead>
                        <tr className="table-light">
                            <th className="text-center">#</th>
                            <th className="text-center">Apellido y Nombre</th>
                            <th className="text-center">Tipo de selección</th> 
                            <th className="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {   audience.audienciaJuezList && audience.audienciaJuezList.length > 0 
                                ?
                                    audience.audienciaJuezList.filter(judge => judge.anulado === 0 || judge.anulado === 1).map( (judge,index)=>(
                                        <tr key={`asaaj${judge.id}`} className={judge.anulado === 1 ? 'table-danger' : ''}>
                                            <td className="align-middle text-center">
                                                { index + 1 }
                                            </td>
                                            <td className="align-middle text-center">
                                                { judge.juez.apellido + ', ' + judge.juez.nombre }
                                            </td>
                                            <td className="align-middle text-center">
                                                {   judge.tipo > 0 && judgeSelectionType.find( type => type.id === judge.tipo) 
                                                        ?   
                                                            judgeSelectionType.find( type => type.id === judge.tipo).descripcion
                                                        : 
                                                            null
                                                }
                                            </td>
                                            <td className="align-middle text-center">
                                                {   (judge.anulado===1) && (judge.motivo!==null)
                                                        ? 
                                                            <Button
                                                                onClick = { () => mostrarMotivo(judge) }
                                                                size = "sm" 
                                                                variant = "info" 
                                                            >
                                                                <ICON_INFO />
                                                            </Button>
                                                        :
                                                            null   
                                                }
                                                {   (audience.estado.id===3) && (judge.anulado===0) && (authorities && Authorities.hasPermission(authorities, JUEZ_RESORTEAR))
                                                        ? 
                                                            <Button
                                                                onClick = { () => mostrarResortear(judge.juez.id) }
                                                                size = "sm"
                                                                variant = "danger"
                                                            >
                                                                <ICON_REFRESH />
                                                            </Button>
                                                        :
                                                            null   
                                                }
                                            </td>
                                        </tr>
                                    ))
                                : 
                                    null
                        }
                    </tbody>
                </table>
            </div>


            <MotivoResorteo
                datosJuez = { datosJuez }
                handleClose = { handleCloseMotivo }
                show = { showMotivo }
            />


            <MotivoResorteoForm
                handleClose = { handleCloseResortear }
                idAudiencia = { audience.id }
                ResorteoDto = { ResorteoDto }
                show = { showResortear }
            />
        </div>
    );
};

export default AudienceActualJudges;
